"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetHeaderProps = void 0;
const react_1 = require("react");
const useSetHeaderProps = (pageViewId) => {
    (0, react_1.useEffect)(() => {
        const timeout = setInterval(() => {
            var _a, _b;
            const setHeaderPropsIsAvailable = typeof window !== 'undefined' &&
                typeof ((_b = (_a = window.nerdwallet) === null || _a === void 0 ? void 0 : _a.ui) === null || _b === void 0 ? void 0 : _b.setHeaderProps) === 'function';
            if (setHeaderPropsIsAvailable && !!pageViewId) {
                window.nerdwallet.ui.setHeaderProps({
                    segmentTrackingAttributes: { driverPageViewId: pageViewId },
                });
                clearInterval(timeout);
            }
        }, 100);
    }, [pageViewId]);
};
exports.useSetHeaderProps = useSetHeaderProps;
